module.exports = __webpack_public_path__ + "static/media/foto3.3c347bac.png";